import React from 'react';
import { PROCESS } from './homeData';

export const ProcessSection = () => (
  <section id="process" className="yv-section yv-dark yv-grid-dark" data-testid="process-section">
    <div className="yv-container">
      <div className="yv-section-head yv-split-head">
        <div>
          <p className="yv-eyebrow">Our Process</p>
          <h2 className="yv-h2">Discover. Architect. <span className="yv-blue-ink yv-block">Implement. Optimize.</span></h2>
        </div>
        <p className="yv-lede">Four Clear Stages, From Understanding Your Operations To Refining Them After Launch.</p>
      </div>
      <ol className="yv-steps4" data-testid="process-timeline">
        {PROCESS.map((p, i) => (
          <li key={p.id} className="yv-step4" style={{ animationDelay: `${i * 90}ms` }} data-testid={`process-${p.id}`}>
            <span className="yv-step4-n yv-mono">{String(i + 1).padStart(2, '0')}</span>
            <h3 className="yv-h3">{p.title}</h3>
            <p>{p.body}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
